import React, { useEffect } from 'react';
import { useTheme } from '@mui/material/styles';
import { PWA_ICON_DARK, PWA_ICON_LIGHT } from '../../constants/pwaBranding';

const Favicon: React.FC = () => {
  const theme = useTheme();
  const mode = theme.palette.mode;

  useEffect(() => {
    const updateFavicon = () => {
      const faviconPath = '/images/favicon1.png';
      const pwaMark =
        mode === 'dark' ? PWA_ICON_DARK : PWA_ICON_LIGHT;

      const existingLinks = document.querySelectorAll('link[rel*="icon"]');
      existingLinks.forEach((link) => link.remove());

      const link = document.createElement('link');
      link.rel = 'icon';
      link.type = 'image/png';
      link.href = faviconPath;
      link.setAttribute('sizes', '32x32');
      document.head.appendChild(link);

      const appleTouchSizes = [
        '57x57',
        '60x60',
        '72x72',
        '76x76',
        '114x114',
        '120x120',
        '144x144',
        '152x152',
        '180x180',
      ];
      appleTouchSizes.forEach((size) => {
        const appleLink = document.createElement('link');
        appleLink.rel = 'apple-touch-icon';
        appleLink.href = pwaMark;
        appleLink.setAttribute('sizes', size);
        document.head.appendChild(appleLink);
      });

      const androidSizes = [
        '36x36',
        '48x48',
        '72x72',
        '96x96',
        '144x144',
        '192x192',
        '256x256',
        '384x384',
        '512x512',
      ];
      androidSizes.forEach((size) => {
        const androidLink = document.createElement('link');
        androidLink.rel = 'icon';
        androidLink.type = 'image/png';
        androidLink.href = pwaMark;
        androidLink.setAttribute('sizes', size);
        document.head.appendChild(androidLink);
      });

      const setMeta = (name: string, content: string) => {
        let meta = document.querySelector(
          `meta[name="${name}"]`,
        ) as HTMLMetaElement | null;
        if (!meta) {
          meta = document.createElement('meta');
          meta.name = name;
          document.head.appendChild(meta);
        }
        meta.content = content;
      };

      setMeta('msapplication-TileImage', pwaMark);
      setMeta('msapplication-TileColor', '#ffffff');
    };

    updateFavicon();
  }, [mode]);

  return null;
};

export default Favicon;
